import { render, staticRenderFns } from "./AlarmHandling.vue?vue&type=template&id=3681f041&scoped=true&"
import script from "./AlarmHandling.vue?vue&type=script&lang=js&"
export * from "./AlarmHandling.vue?vue&type=script&lang=js&"
import style0 from "./AlarmHandling.vue?vue&type=style&index=0&id=3681f041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3681f041",
  null
  
)

export default component.exports